import { render, staticRenderFns } from "./ivr-selector.vue?vue&type=template&id=123177f5"
import script from "./ivr-selector.vue?vue&type=script&lang=js"
export * from "./ivr-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports